import { APIS } from "../../../APIS";
import { IDS } from "../../../IDS";
import { GET, POST } from "../../../Methods";

export const GetAll = async (filter) => {
  return await GET(
    `${APIS.Profile.Bets.LiveBets}?s_date=${filter?.s_date ||
      ""}&e_date=${filter?.e_date || ""}&page=${filter?.page ||
      IDS.PAGE}&per_page=${filter?.per_page || IDS.PERPAGE}`,
  );
};

export const GetAllUnmatchBets = async (filter) => {
  return await GET(
    `${APIS.Profile.Bets.UnmatchBets}?s_date=${filter?.s_date ||
      ""}&e_date=${filter?.e_date || ""}&page=${filter?.page ||
      IDS.PAGE}&per_page=${filter?.per_page || IDS.PERPAGE}`,
  );
};

export const LiveBetsAmount = async (matche_id) => {
  return await GET(
    `${APIS.Profile.Bets.LiveBetsAmount}?matche_id=${matche_id || ""}`,
  );
};

export const BookShow = async (filter) => {
  return await GET(
    `${APIS.Profile.Bets.BookShow}?type_id=${filter?.type_id ||
      ""}&matche_id=${filter?.matche_id || ""}&runner_id=${filter?.runner_id ||
      ""}`,
  );
};

export const BookShowBets = async (id, filter) => {
  return await GET(
    `${APIS.Profile.Bets.BookShowBets}/${id}?type_id=${filter?.type_id ||
      ""}&matche_id=${filter?.matche_id || ""}&runner_id=${filter?.runner_id ||
      ""}`,
  );
};

export const Jackpot = async (filter) => {
  return await GET(
    `${APIS.Profile.Bets.Jackpot}?runner_id=${filter?.runner_id || ""}`,
  );
};

export const RemoveBets = async (id, data = {}) => {
  return await POST(`${APIS.Profile.Bets.RemoveBets}/${id}`, data);
};
